import { HttpService } from '@/shared/services'
import { Certification } from '../models/Certification'
import GenerateCertificationInput from './dtos/GenerateCertificationInput'

const http = new HttpService()

export const getCertifications = async (employeeId: string) => {
  const response = await http.get<Certification[]>(
    `/certifications/${employeeId}`
  )
  return response.data
}

export const generateCertification = async (
  dto: GenerateCertificationInput
) => {
  const response = await http.post<any, any>(
    `/certifications/generate?employeeId=${dto.employeeId}&certificationId=${dto.certificationId}`,
    {},
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Accept: 'application/pdf',
      },
    }
  )
  return response.data
}
